import { useTranslation } from "react-i18next";
import { Dismiss24Regular } from "@fluentui/react-icons";
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  Field,
  makeStyles,
  RadioGroup,
  Radio,
} from "@fluentui/react-components";

// Components
import LanguageSwitcher from "../../../shared/components/LanguageSwitcher";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    alignItems: "flex-start",
  },
});

const PreferencesDrawer = ({ isOpen, setIsOpen, themeName, setThemeName }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const handleChange = (event) => {
    const newTheme = event.target.value;
    setThemeName(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  return (
    <Drawer
      position="end"
      size="small"
      open={isOpen}
      onOpenChange={(event, data) => setIsOpen(data.open)}
      type="overlay"
    >
      <DrawerHeader>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              icon={<Dismiss24Regular />}
              aria-label="Close"
              onClick={() => setIsOpen(false)}
            />
          }
        >
          {t("generic.preferences")}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody>
        <div className={styles.container}>
          <Field label={t("generic.language")} orientation="vertical">
            <LanguageSwitcher />
          </Field>
          <Field label={t("generic.theme")} orientation="vertical">
            <RadioGroup value={themeName} onChange={handleChange} layout="horizontal">
              <Radio value="light" label="Light" />
              <Radio value="dark" label="Dark" />
            </RadioGroup>
          </Field>
        </div>
      </DrawerBody>
    </Drawer>
  );
};

export default PreferencesDrawer;
